import React, { useEffect, useRef } from 'react'
import Uppy from '@uppy/core'
import XHR from '@uppy/xhr-upload'
import Dashboard from '@uppy/dashboard'
import { X } from '@phosphor-icons/react'
import { toast } from '../utils'
const ContentAudioForm = ({ project }) => {
  const uppyRef = useRef(null)
  const dashboardRef = useRef(null)

  useEffect(() => {
    uppyRef.current = new Uppy({
      showProgressDetails: true,
      debug: true,
      restrictions: {
        maxFileSize: 1000 * 1024 * 1024,
        maxNumberOfFiles: 1,
        allowedFileTypes: ['audio/*'],
      },
    }).use(Dashboard, {
      inline: true,
      target: dashboardRef.current,
      proudlyDisplayPoweredByUppy: false,
    }).use(XHR, {
      endpoint: `/projects/${project.id}/uploads`,
      fieldName: 'file',
      headers: {
        'X-CSRF-Token': document.querySelector(
          'meta[name="csrf-token"]')?.content,
      },
    })

    uppyRef.current.on('upload-success', (file, response) => {
      
      if (response.status === 200) {
        toast({message: 'Audio uploaded successfully', type: 'success', duration: 3000, gravity: 'top', position: 'right', close: true})
        Turbo.visit(`/projects/${project.id}/`)
      } else {
        toast({message: 'Error uploading audio', type: 'error', duration: 3000, gravity: 'top', position: 'right', close: true})
      }
    })

    return () => uppyRef.current?.close()
  }, [project.id])

  return (
    <div className="h-full flex flex-col gap-4 p-6">
      <div className="flex-1 flex items-center justify-center max-h-[500px]">
        <div className="max-w-3xl w-full">
          <div ref={dashboardRef} className="uppy-Dashboard w-full"/>
        </div>
      </div>

      <a
        href={`/projects/${project.id}`}
        className="btn btn-outline self-start mx-6 btn-secondary"
      >
        <div className="flex gap-2 items-center">
          <X/>
          <span>Cancel</span>
        </div>
      </a>
    </div>
  )
}

export default ContentAudioForm